namespace TabAurous.Inventory {
    export interface MaterialRequestItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        HasBom: Serenity.BooleanEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        MetalId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: MaterialRequestBOMEditor;
    }

    export class MaterialRequestItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MaterialRequestItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MaterialRequestItemsForm.init)  {
                MaterialRequestItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.BooleanEditor;
                var w4 = CommonCategoryLookup;
                var w5 = CommonSubCategoryLookup;
                var w6 = WeightEditor;
                var w7 = s.DecimalEditor;
                var w8 = AmountEditor;
                var w9 = StoneSieveLookup;
                var w10 = s.DateEditor;
                var w11 = s.ImageUploadEditor;
                var w12 = MaterialRequestBOMEditor;

                Q.initFormType(MaterialRequestItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'Line_No', w0,
                    'BagNo', w0,
                    'SKU', w0,
                    'HSN', w2,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'HasBom', w3,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'MetalId', w2,
                    'Pieces', w1,
                    'Weight', w6,
                    'UnitRate', w7,
                    'StoneRate', w8,
                    'OtherRate', w8,
                    'UnitLabour', w7,
                    'NetAmount', w7,
                    'GrossAmount', w7,
                    'CCNetAmount', w7,
                    'CCGrossAmount', w7,
                    'NetWeight', w6,
                    'DiamondPieces', w1,
                    'DiamondWeight', w6,
                    'StonePieces', w1,
                    'StoneWeight', w6,
                    'OtherPieces', w1,
                    'OtherWeight', w6,
                    'MetalAmount', w7,
                    'DiamondAmount', w7,
                    'StoneAmount', w7,
                    'OtherAmount', w7,
                    'CalcOnId', w2,
                    'UnitCost', w7,
                    'Discount', w7,
                    'WstPer', w7,
                    'WstWt', w6,
                    'Purity', w7,
                    'PureWeight', w6,
                    'Attribute', w0,
                    'CalcUnitId', w2,
                    'KaratId', w2,
                    'MetalColorId', w2,
                    'QualityId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w9,
                    'GroupSieveId', w9,
                    'Remarks', w0,
                    'IsDisabled', w3,
                    'ServerDate', w10,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w10,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w11,
                    'BOMDetails', w12
                ]);
            }
        }
    }
}
